import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, message, Space, Switch, Typography } from 'antd';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { addPost, updatePost, getPostById } from '../../api/localStorage';
import { useParams } from 'react-router-dom';
import './index.css';

const { TextArea } = Input;
const { Title } = Typography;

const WritePost = () => {
  const [form] = Form.useForm();
  const [preview, setPreview] = useState(false);
  const [content, setContent] = useState('');
  const { id } = useParams(); // 获取文章ID参数，用于判断是否为编辑模式

  // 检查是否为编辑模式
  const isEditMode = !!id;

  // 如果是编辑模式，加载文章数据
  useEffect(() => {
    if (isEditMode) {
      const post = getPostById(id);
      if (post) {
        form.setFieldsValue({
          title: post.title,
          author: post.author,
          excerpt: post.excerpt,
          tags: post.tags ? post.tags.join(', ') : '',
          content: post.content
        });
        setContent(post.content);
      } else {
        message.error('文章不存在');
      }
    }
  }, [isEditMode, id, form]);

  const handleSubmit = (values) => {
    const postData = {
      id: isEditMode ? parseInt(id) : undefined, // 编辑时需要包含ID
      title: values.title,
      author: values.author,
      tags: values.tags ? values.tags.split(',').map(tag => tag.trim()) : [],
      excerpt: values.excerpt,
      content: values.content
    };

    try {
      if (isEditMode) {
        // 编辑模式：更新现有文章
        updatePost(postData);
        message.success('文章更新成功！');
      } else {
        // 新建模式：添加新文章
        addPost(postData);
        message.success('文章发布成功！');
      }
      // 编辑完成后不重置表单，以便用户可以继续编辑
      if (!isEditMode) {
        form.resetFields();
        setContent('');
      }
    } catch (error) {
      message.error(isEditMode ? '更新失败，请重试！' : '发布失败，请重试！');
    }
  };

  const handleContentChange = (e) => {
    const value = e.target.value;
    setContent(value);
    form.setFieldsValue({ content: value });
  };

  return (
    <div className="write-post">
      <Card>
        <div className="write-post-header">
          <Title level={2}>{isEditMode ? '编辑文章' : '写文章'}</Title>
          <Space>
            <span>预览模式:</span>
            <Switch checked={preview} onChange={setPreview} />
          </Space>
        </div>
        
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            author: '默认作者'
          }}
        >
          <Form.Item
            name="title"
            label="文章标题"
            rules={[{ required: true, message: '请输入文章标题!' }]}
          >
            <Input placeholder="请输入文章标题" size="large" />
          </Form.Item>
          
          <Form.Item
            name="author"
            label="作者"
            rules={[{ required: true, message: '请输入作者姓名!' }]}
          >
            <Input placeholder="请输入作者姓名" />
          </Form.Item>
          
          <Form.Item
            name="excerpt"
            label="摘要"
            rules={[{ required: true, message: '请输入文章摘要!' }]}
          >
            <Input.TextArea placeholder="请输入文章摘要" rows={3} />
          </Form.Item>
          
          <Form.Item
            name="tags"
            label="标签"
            help="多个标签请用逗号分隔"
          >
            <Input placeholder="例如: React, JavaScript, CSS" />
          </Form.Item>
          
          <Form.Item
            name="content"
            label="内容"
            rules={[{ required: true, message: '请输入文章内容!' }]}
          >
            {preview ? (
              <div className="markdown-preview">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {content}
                </ReactMarkdown>
              </div>
            ) : (
              <TextArea
                placeholder="请输入文章内容，支持Markdown语法"
                rows={15}
                onChange={handleContentChange}
                value={content}
              />
            )}
          </Form.Item>
          
          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                {isEditMode ? '更新文章' : '发布文章'}
              </Button>
              <Button htmlType="button" onClick={() => {
                if (isEditMode) {
                  // 编辑模式下返回到文章详情页
                  window.history.back();
                } else {
                  // 新建模式下清空表单
                  form.resetFields();
                  setContent('');
                }
              }}>
                {isEditMode ? '取消' : '清空'}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default WritePost;